import React, { Component } from "react";

export default class MyAward extends Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultAwards: [],
      allAwards: []
    }
  }

  componentWillMount(){
    const list = this.props.awardList
    const arr = list.filter((_t, i) => i < 2)

    this.setState({allAwards: arr})
  }

  _handleLoadMore() {
    this.setState({allAwards: this.props.awardList})
  }

  _handleLinkTo(param, event) {
    window.location.href = `${param}`
  }

  render() {
    console.log('this.props.awardList:::', this.props.awardList)
    let { allAwards } = this.state
    return (
      <div className="awardWrap">
        <div className="seeMore">
          <div className="award">
            <p>我的奖励</p>
          </div>
          {this.props.awardList.length > 2 ? (
            <div className="more" onClick={this._handleLoadMore.bind(this)}>
            查看更多
            <span className="arrow" />
          </div>
          ) : null}
        </div>
        <div className="awardList">
          {
            allAwards.map((item, index) => {
              return (
                <div className="item" key={index}>
                  <span className="award">{item.rewardName}</span>
                  <span className="btn" onClick={this._handleLinkTo.bind(this, item.rewardURL)}>{item.buttonName}</span>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}